import { mergeRecursive, astonCacheId, registerDateLocale } from '@aston/foundation/functions';
import { AppConstants } from '@aston/foundation/config';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { fr as dateLocaleFr } from 'date-fns/locale/fr';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';

import { environment } from '../environments/environment';

import { AppStoreActions, AppStoreSelectors } from './root-store/app-store';
import { AppConstants as MiddleAppConstants } from './app.constants';
import { AppConfiguration } from './app.configuration';


// override constants with our own
AppConstants.overrideWith(MiddleAppConstants);

// import the locale, used in currencyPipe for format
registerLocaleData(localeFr);
registerDateLocale('fr', dateLocaleFr);

export function translateLoader(
	http: HttpClient,
	config: AppConfiguration) {
	console.log('environment', environment)
	const filesToConsider = environment[ 'translations' ].filenames.map(f => {
		return { prefix: './assets/i18n/' + f + '.', suffix: '.json' };
	});
	return new MultiTranslateHttpLoader(http, config, filesToConsider);
}

/* custom translation loader, extends the translation file to merge multiple files into a single one */

/* original => https://github.com/ngx-translate/http-loader/issues/44#issuecomment-412510056 */
export class MultiTranslateHttpLoader implements TranslateLoader {
	constructor(
		private http: HttpClient,
		private config: AppConfiguration,
		public resources: { prefix: string, suffix: string }[] = [{ prefix: '/assets/i18n/', suffix: '.json' }]) {
	}

	public getTranslation(lang: string): any {
		return this.config.appConfigLoaded$.pipe(
			map(_ => {
				const resourcesNames = this.resources
					.sort((a, b) => a.prefix.indexOf('v2') < b.prefix.indexOf('v2') ? -1 : 1);

				return resourcesNames.map(resourceName => this.http.get(`${resourceName.prefix}${lang}${resourceName.suffix}${astonCacheId()}`));
			}),
			mergeMap(calls => forkJoin(calls)),
			map(responses => responses.reduce((a, b) => mergeRecursive(a, b))));
	}
}

export function appConfigurationFactory(store: Store): CallableFunction {
	return () => new Promise(resolve => {
		store.dispatch(AppStoreActions.StartInitializer());
		store.select(AppStoreSelectors.selectIsInitFinished).pipe(filter(ready => ready)).subscribe(_ => {
			resolve(true);
		});
	});
}
